const TRAINING_PLAN_CLASS_NAME = 'Plan'

const TRAINING_PLAN_KEY = {
  ID: 'id',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CLASS_NAME: 'className',
  NAME: 'name',
  LEVEL: 'level',
  DIFFICULTY: 'difficulty',
  NOTES: 'notes',
  INSTRUCTIONS: 'instructions',
  STARTED_AT: 'startedAt',
  LOGGED_AT: 'loggedAt',
  FEATURED_AT: 'featuredAt',
  RECOMMENDED_AT: 'recommendedAt',
  WEEKS_COUNT: 'weeksCount',
  WORKOUTS_COUNT: 'workoutsCount',
  WORKOUTS_COMPLETED_COUNT: 'workoutsCompletedCount',
  EQUIPMENT: 'equipment',
  MUSCLES: 'muscles',
  SECONDARY_MUSCLES: 'secondaryMuscles',
  TYPES: 'types',
  IMAGE: 'image',
  WORKOUTS: 'workouts',
  DAYS: 'days',
  STRIPE_PRICE: 'stripePrice',
  STRIPE_PRODUCT: 'stripeProduct',
  // Foreign keys
  PROFILE_ID: 'profileId',
  PARENT_ID: 'parentId',
  ORIGINAL_PARENT_ID: 'originalParentId'
}

export {
  TRAINING_PLAN_KEY,
  TRAINING_PLAN_CLASS_NAME
}
